import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Filter from 'Components/Common/Filter/Filter';
import DropdownMenuGroupYear from 'Components/Common/EC/DropdownMenuGroupYear';
import TableList from './TableList';
import SpinnerComponent from 'Components/Common/SpinnerComponent';
import useMessage from 'Hooks/useMessage';
import { ECApis } from 'Datasource/EC';
import dayjs from 'dayjs';

interface GroupDate {
  year: string;
}

const currentYear = dayjs().year();

export default function PaymentAdviceList(): JSX.Element {
  const { openMessageError } = useMessage();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [groupOptions, setGroupOptions] = useState<Array<GroupDate>>([
    { year: `${currentYear}年` },
  ]);
  const [activeOption, setActiveOption] = useState(groupOptions[0]?.year);

  const fetchGroupDate = async () => {
    setIsLoading(true);
    try {
      const res = await ECApis.getTranferGroupDate();
      const { data } = res.data;
      setGroupOptions(data);
    } catch (error) {
      openMessageError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGroupDate();
  }, []);

  return (
    <Container fluid>
      <SpinnerComponent isLoading={isLoading} />

      <Filter filterClass={`shadow-sm `}>
        <div>表示年</div>
        <DropdownMenuGroupYear
          options={groupOptions}
          activeOption={activeOption}
          onChange={setActiveOption}
          classButton="payment-advice-dropdown-menu"
        />
      </Filter>
      <TableList year={activeOption}></TableList>
    </Container>
  );
}
